import styled from "styled-components";
import { breakpoints } from "styles";
import { rem } from "polished";
import PlayButton from "public/assets/play-button.png";

export const AkademiMain = styled.main``;

export const BannerWrapper = styled.section`
  background: radial-gradient(
    circle,
    rgba(21, 69, 211, 0.7) 0%,
    rgba(26, 88, 241, 1) 30%,
    rgba(25, 72, 205, 1) 100%
  );
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 16px;
`;

export const BannerContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  gap: ${rem(32)};
  justify-content: center;
  align-items: center;
  @media ${breakpoints.mobile} {
    flex-direction: column;
    gap: 0;
    padding: 0 16px 56px;
  }
  @media ${breakpoints.tablet} {
    flex-direction: column;
    padding-left: 5%;
    padding-right: 5%;
  }
  @media ${breakpoints.laptop} {
    flex-direction: column;
    padding-left: 10%;
    padding-right: 10%;
  }
`;

export const BannerTitle = styled.h2`
  position: absolute;
  top: 120px;
  font-family: ${({ theme }) => theme.fonts.primary};
  line-height: 46px;
  color: ${({ theme }) => theme.colors.white};
  font-size: ${({ theme }) => theme.fontSizes["4xl"]};
  margin: 0 0 16px;
  text-align: center;
  z-index: 10;
  text-wrap: balance;
`;

export const BannerBlockCTA = styled.a`
  position: absolute;
  top: 280px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  gap: 8px;
  height: 24px;
  width: fit-content;
  cursor: pointer;
  font-weight: bold;
  padding: 12px 24px;
  text-decoration: none;
  font-family: ${({ theme }) => theme.fonts.primary};
  background-color: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.brand[500]};
`;

export const AboutWrapper = styled.section`
  background-color: ${({ theme }) => theme.colors.yellow["50"]};
  display: flex;
  flex-direction: row;
  position: relative;
  align-items: center;
  justify-content: center;
`;

export const AboutContainer = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
  align-items: center;
  justify-content: center;
  gap: 54px;
  padding: 80px 0;
`;

export const AboutTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 0 16px;
  position: relative;
  width: 600px;
`;

export const AboutText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  max-width: 950px;
  .title {
    font-family: ${({ theme }) => theme.fonts.primary};
    line-height: 24px;
    font-size: ${({ theme }) => theme.fontSizes["4xl"]};
    font-weight: 700;
    margin: 0 0 16px;
    text-align: left;
    text-wrap: balance;
  }
  .desc {
    margin: 0;
    font-family: ${({ theme }) => theme.fonts.secondary};
    font-size: ${({ theme }) => theme.fontSizes["xl"]};
    text-align: left;
  }
`;

export const AboutVideoThumbContainer = styled.div`
  position: relative;
  align-self: center;

  iFrame {
    border-radius: 4px;
    width: 410px;
    height: 230px;
  }

  .thumbnail {
    width: 410px;
    height: 230px;
    background-size: cover;
    background-position: center;
    border-radius: 4px;
  }

  .play-button {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 64px;
    height: 64px;
    background: url(${PlayButton.src}) no-repeat center center;
    background-size: contain;
    border: none;
    cursor: pointer;
  }
`;

export const AboutCTA = styled.a`
  display: flex;
  align-items: center;
  width: fit-content;
  text-align: center;
  cursor: pointer;
  gap: 8px;
  height: 36px;
  padding: 10px 20px;
  background-color: ${({ theme }) => theme.colors.brand["500"]};
  color: ${({ theme }) => theme.colors.white};
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: 700;
  border-radius: 6px;
`;
